function toArrayBufferForSubtle(view: ArrayBufferView): ArrayBuffer {
  const { buffer, byteOffset, byteLength } = view;

  if (
    buffer instanceof ArrayBuffer &&
    byteOffset === 0 &&
    byteLength === buffer.byteLength
  ) {
    return buffer;
  }

  const out = new Uint8Array(byteLength);
  out.set(new Uint8Array(buffer, byteOffset, byteLength));
  return out.buffer;
}

export const sha1 = async (data: Uint8Array): Promise<string> => {
  let subtle: Pick<SubtleCrypto, 'digest'>;
  if (typeof window === 'undefined') {
    const { webcrypto } = await import('node:crypto');
    if (!webcrypto) {
      throw new Error(
        'WebCrypto module is not supported in this Node.js environment',
      );
    }
    subtle = webcrypto.subtle;
  } else {
    subtle = window.crypto.subtle;
  }

  const arrayBuffer = toArrayBufferForSubtle(data);

  const hash = await subtle.digest('SHA-1', arrayBuffer);
  const hashHex = Array.from(new Uint8Array(hash))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');

  return hashHex;
};
